module.exports = __webpack_public_path__ + "img/zfb.c4e91ffe.png";